module.exports = __webpack_public_path__ + "static/media/K-Hearts.1db3bb01.svg";